import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { environment } from '../../../environments/environment';

export interface MarketingProfile {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string | null;
  city: string;
  sex: string | null;
  age: number | null;
  ageBracket: { label: string; share: number } | null;
  avatarUrl: string | null;
  createdAt: string | null;
  lastLoginAt: string | null;
  segment: string;
  lastActionDaysSince: number | null;
  nearby: { radiusInKm: number; total: number; sameSport: { name: string; count: number }[] } | null;
  activityTopShare: number | null;
  involvedCount: number;
  createdCount: number;
  timeline: { title: string; kind: string; startDate: string; upcoming: boolean; attendees: number }[];
  groups: { name: string; isAdmin: boolean; members: number }[];
  money: { paid: number; refunded: number; released: number };
  sports: { name: string; level: number | null; maxLevel: number | null; declaredAt: string | null }[];
  completeness: { field: string; filled: boolean }[];
  hasPush: boolean;
  hasCustomNotifications: boolean;
  pushSwitches: Record<string, boolean | null>;
  mailSwitches: Record<string, boolean | null>;
  position: { lat: number; lon: number } | null;
  signals: { key: string; params: Record<string, string | number> }[];
}

/** One member's sheet, loaded per visit. */
@Injectable({ providedIn: 'root' })
export class MarketingProfileStoreService {
  #http = inject(HttpClient);

  readonly profile = signal<MarketingProfile | null>(null);
  readonly loading = signal(false);
  readonly failed = signal(false);

  load(userId: string): void {
    this.loading.set(true);
    this.failed.set(false);
    this.profile.set(null);

    this.#http
      .get<MarketingProfile>(`${environment.api}/api/v1/admin/users/marketing-profile/${userId}`)
      .subscribe({
        next: (res) => {
          this.loading.set(false);
          this.profile.set(res ?? null);
        },
        error: () => {
          this.loading.set(false);
          this.failed.set(true);
        },
      });
  }
}
